module.exports = __webpack_public_path__ + "static/media/2. Submit 1st standup answer.b8a66613.svg";